import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { CriarTokenPessoalDto } from "@base/contracts";
import { useAuth } from "../../../shared/auth/auth.contexto";
import { useTokensPessoaisGateway } from "./mcp.contexto";

const CHAVE = "tokens-pessoais";

export function useTokensPessoais() {
  const gateway = useTokensPessoaisGateway();
  const { sessao } = useAuth();
  return useQuery({
    queryKey: [CHAVE, sessao?.tenantId],
    queryFn: () => gateway.listar(),
  });
}

export function useCriarTokenPessoal() {
  const gateway = useTokensPessoaisGateway();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (corpo: CriarTokenPessoalDto) => gateway.criar(corpo),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: [CHAVE] });
    },
  });
}

export function useRevogarTokenPessoal() {
  const gateway = useTokensPessoaisGateway();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => gateway.revogar(id),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: [CHAVE] });
    },
  });
}
